import * as Reducer from './slice';
import { findAction, pickAction } from './utils';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IBridgeState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getState = (state: IAppState) => state[Reducer.statePropName];

export const isBridgeLoaded = (state: IAppState) => getState(state).loaded;

export const getBridgeActions = (state: IAppState) => getState(state).actions;

export const getCurrentActionFilterId = (state: IAppState) => getState(state).current;

export const getCurrentAction = (state: IAppState) => {
  const filterid = getCurrentActionFilterId(state);
  const actions = getBridgeActions(state);
  const currentAction = findAction(actions, filterid);
  return currentAction ? pickAction(currentAction) : undefined;
};

export const isBridgeActive = (state: IAppState) => {
  const filterid = getCurrentActionFilterId(state);
  const action = getCurrentAction(state);
  return filterid > 0 && !!action;
};

export const findActionByFilterId = (state: IAppState, filterid: number) => {
  const actions = getBridgeActions(state);
  const action = findAction(actions, filterid);
  return action ? pickAction(action) : undefined;
};

export const getParameters = (state: IAppState) => getState(state).params;

export const getParameterValue = (state: IAppState, paramName: string) => {
  const parameters = getParameters(state);
  if (!parameters[paramName]) {
    return undefined;
  }
  return parameters[paramName];
};
